import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');
export default class ManageArticle extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		let parms = "";
		//JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
        console.log("parms => " + parms);

		this.state={
			blog : {			
				"blogId": 0,
				"topic": "",
				"fullText" : "",
				"contentId" : 0,
				"contentList" : "",
				"contextId" : "",
				"createUser": this.props.userId,
				"createDate": new Date(),
				"lastUpdateUser": this.props.userId,
				"lastUpdateDate": new Date()
			}
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({blog : {...this.state.blog, [target.id] : target.value} });
	   
		console.log(this.state);
	  }
	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	
		var idUrl = `${global.config.securityServicesUrl}/next-id-generator/get-next/blogs/blogId`;
	  	var url = `${global.config.apiServicesUrl}/blogs`;

  		axios.get(idUrl).then(response => {
		  	this.setState({blog : {...this.state.blog, blogId : response.data["nextId"]}});
	  
			console.log("new blog id = " + JSON.stringify(this.state.blog.blogId));
	
			console.log('saving state.blog => ' + JSON.stringify(this.state.blog));
			
			axios.post(url, this.state.blog).then(response2 => {
				console.log("response.data");
				console.log(response2.status +":"+response2.data.blogId);
				if (response2.status === 200 )
				{
					this.message = "Success";
					this.handleClear();	
				}
				else
				{
					 this.message = "Failed";
				}        
				console.log(this.message);
		  	}).catch(err => {
				console.log("error - " + err);
		  	});
		  });
		console.log("message info - " + this.message); 
		//		
	 };
	 handleClear(){
		 this.setState({blog : {			
				"blogId": 0,
				"topic": "",
				"fullText" : "",
				"contentId" : 0,
				"contentList" : "",
				"contextId" : 0,
				"createUser": Number(this.props.userId),
				"createDate": new Date(),
				"lastUpdateUser": Number(this.props.userId),
				"lastUpdateDate": new Date()
			}})
	 }
	 componentDidMount() 
	 {
	 	this.handleClear();
	 }

	handleOnLoad = () => {
		this.handleClear();
	 }
	
	render(){
    return (
        	<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
		
		<form>
		<div class="container-fluid">
		<h4>Create Article</h4>
		<hr />
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Topic</label>
		<input id="topic" class="form-control input-medium col-sm-8" value={this.state.blog.topic} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Article</label>
		<textarea id="fullText" class="form-control input-medium col-sm-8" rows="18" 
			value={this.state.blog.fullText} onChange ={this.handleChange}> 
		</textarea>
		</div>

				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Attachments</label>
			<select id="contentList" class="form-control input-medium col-sm-8" value={this.state.blog.contentList} onChange ={this.handleChange}/>
			</div>
		<hr />
		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Post To Twitter</label>
			<input type="checkbox" value="Twitter" ></input>&nbsp;&nbsp;
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Post To LinkedIn</label>
			<input type="checkbox" value="LinkedIn" />&nbsp;&nbsp;
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Post To Facebook</label>
			<input type="checkbox" value="Facebook" />&nbsp;&nbsp;
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Post To Instagram</label>
			<input type="checkbox" value="Instagram" />
		</div>

		<hr />	
					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Create" onClick ={this.handleSubmit}>Save</button>&nbsp;
		</div>		
		</form>
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
	);
}
}